import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout
      title="Impressum"
      eyebrow="Angaben gemäß § 5 TMG"
      lastUpdated="Dezember 2025"
    >
      <Section heading="Anbieter">
        <p>
          <strong className="text-white">Daniel Lopes Music UG (haftungsbeschränkt)</strong>
          <br />
          Tivolistraße 75
          <br />
          52349 Düren
          <br />
          Deutschland
        </p>
      </Section>

      <Section heading="Kontakt">
        <p>
          E-Mail:{" "}
          <a
            href="mailto:booking@daniellopes.net"
            className="text-[#D4AF37] hover:underline"
            data-testid="impressum-email"
          >
            booking@daniellopes.net
          </a>
        </p>
      </Section>

      <Section heading="Vertretungsberechtigter Geschäftsführer">
        <p>Daniel Lopes</p>
      </Section>

      <Section heading="Registereintrag">
        <p>
          Eintragung im Handelsregister
          <br />
          Registergericht: Amtsgericht Düren
          <br />
          Registernummer: HRB [bitte nachtragen]
        </p>
      </Section>

      <Section heading="Umsatzsteuer-ID">
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
          <br />
          DE [bitte nachtragen]
        </p>
      </Section>

      <Section heading="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
        <p>
          Daniel Lopes
          <br />
          Tivolistraße 75, 52349 Düren
        </p>
      </Section>

      <Section heading="EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#D4AF37] hover:underline"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          .
          <br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </Section>

      <Section heading="Verbraucher­streit­beilegung / Universal­schlichtungs­stelle">
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Section>

      <Section heading="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine
          rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich.
        </p>
      </Section>

      <Section heading="Haftung für Links">
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
          der Seiten verantwortlich.
        </p>
      </Section>

      <Section heading="Urheberrecht">
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
          diesen Seiten unterliegen dem deutschen Urheberrecht. Die
          Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
          Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
          schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
      </Section>
    </LegalLayout>
  );
}
